const CANDIDATES = [
  "a",
  "button",
  "input",
  "select",
  "textarea",
  "svg",
  "area",
  "details",
  "summary",
  "iframe",
  "object",
  "embed",
  "[tabindex]",
  "[contenteditable]",
].join(", ");

/**
 * Trap focus in a given element.
 *
 * Returns a function which will release focus again.
 *
 * Based on https://grrr.tech/posts/trap-keyboard-tab-focus-in-element-in-accessible-aria-modal-dialog/
 */
export default function trapFocus(
  focusNode: Element,
  rootNode: Document = document
): () => void {
  const nodes = [...rootNode.querySelectorAll(CANDIDATES)].filter(
    (node) =>
      !focusNode.contains(node) && node.getAttribute("tabindex") !== "-1"
  );

  for (const node of nodes) node.setAttribute("tabindex", "-1");

  return function releaseFocus() {
    for (const node of nodes) node.removeAttribute("tabindex");
  };
}
